import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Login from "./Authentication/Login/Login";
import ProtectedRoute from "./Components/ProtectedRoute";
import ResetPassword from "./Authentication/ResetPassword/ResetPassword";
import SetNewPassword from "./Authentication/SetNewPassword/SetNewPassword";
import ResetPasswordSuccess from "./Authentication/ResetPasswordSuccess/ResetPasswordSuccess";
import NotFound from "./Pages/NotFound/NotFound";
import DashboardLayout from "./Pages/Dashboard/DashboardLayout";
import DashboardHome from "./Pages/Dashboard/DashboardHome/DashboardHome";
import Profile from "./Pages/Dashboard/Profile/Profile";
import ChangePassword from "./Authentication/ChangePassword/ChangePassword";
import UserListing from "./Pages/Dashboard/UserListing/UserListing";
import AddUser from "./Pages/Dashboard/UserListing/AddUser/AddUser";
import EditUser from "./Pages/Dashboard/UserListing/EditUser/EditUser";
import Leads from "./Pages/Dashboard/Leads/Leads";
import AddLead from "./Pages/Dashboard/Leads/AddLead/AddLead";
import UniversityListing from "./Pages/Dashboard/UniversityListing/UniversityListing";
import CourseListing from "./Pages/Dashboard/CourseListing/CourseListing";
import ScholarshipListing from "./Pages/Dashboard/ScholarshipListing/ScholarshipListing";
import AddCourse from "./Pages/Dashboard/CourseListing/AddCourse/AddCourse";
import EditCourse from "./Pages/Dashboard/CourseListing/EditCourse/EditCourse";
import AddUniversity from "./Pages/Dashboard/UniversityListing/AddUniversity/AddUniversity";
import EditUniversity from "./Pages/Dashboard/UniversityListing/EditUniversity/EditUniversity";
import AddScholarship from "./Pages/Dashboard/ScholarshipListing/AddScholarship/AddScholarship";
import JobApplicationListing from "./Pages/Dashboard/JobApplicationListing/JobApplication";
import UEC2026 from "./Pages/Dashboard/UEC2026/UEC2026";
import SPM2026 from "./Pages/Dashboard/SPM2026/SPM2026";
import ManualResetPassword from "./Pages/Dashboard/ManualResetPassword/ManualResetPassword";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />}></Route>
        <Route path="/set-new-password" element={<SetNewPassword />}></Route>
        <Route
          path="/reset-password-success"
          element={<ResetPasswordSuccess />}
        ></Route>

        {/* Protected Route */}
        <Route
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/profile" element={<Profile />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/dashboard" element={<DashboardHome />} />
          {/* Leads */}
          <Route
            path="/leads"
            element={
              <ProtectedRoute
                allowedRole={[
                  "super admin",
                  "admin",
                  "sales",
                  "part-time sales",
                  "IT",
                  "Branch Manager",
                ]}
              >
                <Leads />
              </ProtectedRoute>
            }
          />
          <Route
            path="/leads/add-lead"
            element={
              <ProtectedRoute
                allowedRole={[
                  "super admin",
                  "admin",
                  "sales",
                  "part-time sales",
                  "IT",
                  "Branch Manager",
                ]}
              >
                <AddLead />
              </ProtectedRoute>
            }
          />

          <Route
            path="/uec2026"
            element={
              <ProtectedRoute
                allowedRole={[
                  "super admin",
                  "admin",
                  "sales",
                  "part-time sales",
                  "IT",
                  "Branch Manager",
                ]}
              >
                <UEC2026 />
              </ProtectedRoute>
            }
          />

          <Route
            path="/spm2026"
            element={
              <ProtectedRoute
                allowedRole={[
                  "super admin",
                  "admin",
                  "sales",
                  "part-time sales",
                  "IT",
                  "Branch Manager",
                ]}
              >
                <SPM2026 />
              </ProtectedRoute>
            }
          />

          {/* User Listing */}
          <Route
            path="/user-listing"
            element={
              <ProtectedRoute allowedRole={["super admin", "admin", "IT"]}>
                <UserListing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-listing/add-user"
            element={
              <ProtectedRoute allowedRole={["super admin", "admin", "IT"]}>
                <AddUser />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-listing/edit-user/:id"
            element={
              <ProtectedRoute allowedRole={["super admin", "admin", "IT"]}>
                <EditUser />
              </ProtectedRoute>
            }
          />
          <Route
            path="/manual-reset-password"
            element={
              <ProtectedRoute allowedRole={["super admin", "admin"]}>
                <ManualResetPassword />
              </ProtectedRoute>
            }
          />
          {/* University Listing */}
          <Route
            path="/university-listing"
            element={
              <ProtectedRoute
                allowedRole={["super admin", "admin", "content editor", "IT"]}
              >
                <UniversityListing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/university-listing/add-university"
            element={
              <ProtectedRoute
                allowedRole={["super admin", "admin", "content editor", "IT"]}
              >
                <AddUniversity />
              </ProtectedRoute>
            }
          />
          <Route
            path="/university-listing/edit-university/:id"
            element={
              <ProtectedRoute
                allowedRole={["super admin", "admin", "content editor", "IT"]}
              >
                <EditUniversity />
              </ProtectedRoute>
            }
          />
          {/* Course Listing */}
          <Route
            path="/course-listing"
            element={
              <ProtectedRoute
                allowedRole={["super admin", "admin", "content editor", "IT"]}
              >
                <CourseListing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course-listing/add-course"
            element={
              <ProtectedRoute
                allowedRole={["super admin", "admin", "content editor", "IT"]}
              >
                <AddCourse />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course-listing/edit-course/:id"
            element={
              <ProtectedRoute
                allowedRole={["super admin", "admin", "content editor", "IT"]}
              >
                <EditCourse />
              </ProtectedRoute>
            }
          />

          {/* Scholarship Listing */}
          <Route
            path="/scholarship-listing"
            element={
              <ProtectedRoute
                allowedRole={["super admin", "admin", "content editor", "IT"]}
              >
                <ScholarshipListing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/scholarship-listing/add-scholarship"
            element={
              <ProtectedRoute
                allowedRole={["super admin", "admin", "content editor", "IT"]}
              >
                <AddScholarship />
              </ProtectedRoute>
            }
          />

          {/* Job Application Listing */}
          <Route
            path="/job-application-listing"
            element={
              <ProtectedRoute allowedRole={["super admin", "admin"]}>
                <JobApplicationListing />
              </ProtectedRoute>
            }
          />
        </Route>

        <Route path="/page-not-found" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/page-not-found" replace />} />
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
}
